<template>
  <v-card  class="kim-card coupon-card text-center" elevation="5">
    <v-card-title :class="['white--text title text-center text-truncate', cardColor]">
      <div class="title mx-auto ">
        {{coupon.name}}
      </div>

      <v-flex xs12 pt-2 pb-0 text-center>
        <div class="display-2 font-weight-regular text-center">
          {{amount}}<span class="headline ">{{currency}}</span> <span class="body-1"></span>
        </div>
      </v-flex>

      <v-flex py-0 xs12 text-center>
        <v-card dark class="kim-card">
          <v-card-text>
            <small class="caption">código:</small>
            <br>
            <small class="title">{{coupon.code}}</small>
          </v-card-text>
        </v-card>
      </v-flex>

    </v-card-title>
    <v-divider></v-divider>
    <v-card-text class="pb-0">
      <v-sheet>
        <v-list dense>
          <feature-item :color="cardColor" :disabled="disabled" icon="fa-calendar-alt" :text="`Aplica para: ${coupon.times} ${coupon.times > 1 ? 'meses' : 'mes'}`" />
          <feature-item :color="cardColor" icon="fa-hourglass-start" :text="`Expira en: <b>${$moment(coupon.expires).format('DD-MM-Y')}</b>`" />
        </v-list>
      </v-sheet>

    </v-card-text>
    <template  v-if="redeemedBy">
      <v-card-text>
        <span class="caption">Canjeado por: {{redeemedBy.first_name}} {{redeemedBy.last_name}}</span>
      </v-card-text>
    </template>
    <template v-else>
      <template v-if="internal">

        <v-divider class="mt-2" ></v-divider>

        <div class="text-center py-2">
          <small v-if="serviceProvider">Creado para <b>{{serviceProvider}}</b></small>
          <small>Creado por <b>{{coupon.user.first_name}} {{coupon.user.last_name}}</b></small>
        </div>

      </template>
      <v-card-actions v-if="internal" >
        <v-btn rounded :color="cardColor"  style="width: 100%" @click="$emit('click:edit', coupon)">
          <v-icon class="mr-2" size="16">fa-eye</v-icon>
          Ver
        </v-btn>
      </v-card-actions>
    </template>

  </v-card>
</template>

<script>
import FeatureItem from "@/components/admin/FeatureItem";
export default {
  name: "CouponCard",
  components: {FeatureItem},
  props: {
    internal:{
      type: Boolean,
      default: false
    },
    coupon:{
      type: Object,
      required: true
    }
  },
  computed:{
    disabled(){
      const vm = this
      return vm.coupon && Boolean(vm.coupon.redeemed)
    },
    cardColor(){
      const vm = this
      if(vm.disabled){
        return 'grey darken-1'
      }

      return 'secondary'
    },
    amount(){
      const vm = this

      if(vm.coupon.percent_off){
        return Math.floor(vm.coupon.percent_off * 100) / 100
      }

      return vm.currency === 'UF' ?
          Math.floor(vm.coupon.amount * 100) / 100 : vm.coupon.amount
    },
    currency(){
      const vm = this

      if(vm.coupon.percent_off){
        return '%'
      }

      return vm.coupon.currency
    },
    serviceProvider(){
      const vm = this
      const {service_provider} = vm.coupon
      return service_provider ?
          (
              service_provider.institution && service_provider.institution.name
              || `${service_provider.user.first_name} ${service_provider.user.last_name} `
          ) : null
    },
    redeemedBy(){
      const vm = this
      return vm.coupon && vm.coupon.redeemed_by || null
    }
  }
}
</script>

<style scoped>
  .coupon-card{
    padding: 0;
  }
</style>
